<app-menu></app-menu>
<div class="appContentsContainer">
  <form
    [formGroup]="password"
    (ngSubmit)="onSave()"
    class="formGroup container halfForm wrapHalfRows"
  >
    <div class="collapseButtonContainer">
      <div class="pageTitle collapsibleTitle">
        {{ "changePassword.title" | translate }}
      </div>
    </div>

    <div class="halfGroup">
      <div class="row compressedRow">
        <div class="passwordContainer itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="label passwordLabel inputLabel">
              <label id="chPassword" for="chPassword">Contraseña actual</label>
            </div>
          </div>
          <div class="inputContainer passwordInputForm inputText">
            <input
              type="{{ showChPassword ? 'password' : 'text' }}"
              formControlName="chPassword"
            />
            <div class="supIndexRequest">*</div>
            <div (click)="changeView('chPassword')" style="cursor: pointer">
              <span *ngIf="showChPassword" class="icon">
                <i class="fas fa-eye"></i>
              </span>
              <span *ngIf="!showChPassword" class="icon">
                <i class="fas fa-eye-slash"></i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="passwordContainer itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="label passwordLabel inputLabel">
              <label id="chNewPassword" for="chNewPassword"
                >Nueva contraseña</label
              >
            </div>
          </div>
          <div class="inputContainer passwordInputForm inputText">
            <input
              type="{{ showChNewPassword ? 'password' : 'text' }}"
              formControlName="chNewPassword"
            />
            <div class="supIndexRequest">*</div>
            <div (click)="changeView('chNewPassword')" style="cursor: pointer">
              <span *ngIf="showChNewPassword" class="icon">
                <i class="fas fa-eye"></i>
              </span>
              <span *ngIf="!showChNewPassword" class="icon">
                <i class="fas fa-eye-slash"></i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="passwordContainer itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="label passwordLabel inputLabel">
              <label id="chNewPasswordConfirm" for="chNewPasswordConfirm"
                >Confirmar nueva contraseña</label
              >
            </div>
          </div>
          <div class="inputContainer passwordInputForm inputText">
            <input
              type="{{ showChNewPasswordConfirm ? 'password' : 'text' }}"
              formControlName="chNewPasswordConfirm"
            />
            <div class="supIndexRequest">*</div>
            <div
              (click)="changeView('chNewPasswordConfirm')"
              style="cursor: pointer"
            >
              <span *ngIf="showChNewPasswordConfirm" class="icon">
                <i class="fas fa-eye"></i>
              </span>
              <span *ngIf="!showChNewPasswordConfirm" class="icon">
                <i class="fas fa-eye-slash"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="buttonsGroup">
      <div class="backButton">
        <button
          class="formButtonBack"
          type="button"
          *ngIf="!password.pristine"
          [swal]="confirmSwal"
        >
          <em class="fas fa-times fa-2x backButtonAlign"></em>
        </button>
        <button
          class="formButtonBack"
          type="button"
          *ngIf="password.pristine"
          (click)="goPredefinedMailBox()"
        >
          <em class="fas fa-times fa-2x backButtonAlign"></em>
        </button>
      </div>
      <div class="okButton">
        <div class="centerButton">
          <button class="formButtonOk" type="submit">
            {{ "commons.ok" | translate }}
          </button>
        </div>
      </div>
    </div>
    <swal
      #confirmSwal
      html="<strong>Tienes cambios sin guardar <br/> ¿Quieres volver sin guardar?</strong>"
      icon="warning"
      [showCancelButton]="true"
      [swalOptions]="{
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        allowEscapeKey: false,
        allowOutsideClick: false
      }"
      [focusCancel]="true"
      (confirm)="goPredefinedMailBox()"
    >
    </swal>
    <swal
      #infoSwal
      html="<strong>La contraseña se ha cambiado correctamente, debe autenticarse de nuevo en el sistema para volver a entrar.</strong>"
      icon="warning"
      [swalOptions]="{
        confirmButtonText: 'Aceptar',
        allowEscapeKey: false,
        allowOutsideClick: false
      }"
    >
    </swal>
  </form>
</div>
